// @flow

import updateEstimateField from '../../../Services/updateEstimateField';

export default (value: string) => async (dispatch: Function) => {

  dispatch(updateEstimateField('notes', value))

}